/**
 * Created by hieult on 1/11/18.
 */

import { ICategoryTab } from 'redhotpie-shared-lib/interfaces/ICategory';

export default class CategoryTab {
  data: any[];
  constructor() {
    this.data = [];
  }

  static mappingObject(categoryTab: any): ICategoryTab {
    const tab = new CategoryTab();
    tab.data = categoryTab.data || [];
    return tab;
  }
}
